var GeodirLayerAdmin = (function () {
	var instance;
	function LayerAdmin(GEODIR) {
		this.GEODIR = GEODIR;
		// always initialize all instance properties
		this.layers = {
			baseLayers: {},
			overlays: {}
		};
		var template;
		this._container = null;
		this.addEvent = null,// new Event('addLayer');
			this.removeEvent = null,//new Event('removeLayer');
			this.changeLayerEvent = null,// new Event('changeLayerEvent');
			this.filterLayerEvent = null,//new Event('filterLayerEvent');
			this.idLayerList = 'geodir-layer-list';
		this.map = null;
		this.currentLayer = null;
		this.currentLayerId = GEODIR.CurrentLayerId;
		this.currentLayerColumns = [];
		this.controlLayer = true;
		this.mapcontrols = {};
		this.maplayers = {
			columns: {},
			layers: {},
			widgets: {}
		};

	}

	LayerAdmin.prototype.getMapControl = function (name) {
		if (this.mapcontrols.hasOwnProperty(name)) {
			return this.mapcontrols[name];
		}
		return null;
	};

	LayerAdmin.prototype.getContext = function () {
		return this.serverContext;
	};
	LayerAdmin.prototype.cancelControlActions = function (fn) {
		for (let controlName in this.mapcontrols) {
			if (this.mapcontrols[controlName] instanceof L.Control.Geodir) {
				this.mapcontrols[controlName]._cancelAction();
			}
		}

		if (fn) {
			fn();
		}
	};
	//
	// class methods
	LayerAdmin.prototype.getLayers = function () {
		return this.layers.overlays;
	};
	LayerAdmin.prototype.getLayersById = function (id) {
		return this.layers.overlays[id];
	};
	LayerAdmin.prototype.styleLayer = function (sld_url, tiled) {
		let currentLayer = this.getCurrentLayer();
		let changeTiled = false;
		if (currentLayer != null) {
			if (currentLayer.data.tiled != tiled) {
				changeTiled = true;
			}
			currentLayer.data.tiled = tiled;
			currentLayer.data.sld = sld_url;
			currentLayer.layer.setStyle(sld_url);
			if (tiled) {
				if (!changeTiled) {
					currentLayer.layer.updateMapaStyle();
				} else {
					this.changeLayer(currentLayer.data, currentLayer.data.id);
					let context = this;
					context.currentLayerId = currentLayer.data.id;
					context.currentLayer = context.layers.overlays[currentLayer.data.id];
				}

			} else {
				this.changeLayer(currentLayer.data, currentLayer.data.id);
				let context = this;
				context.currentLayerId = currentLayer.data.id;
				context.currentLayer = context.layers.overlays[currentLayer.data.id];
			}

		}
	};
	LayerAdmin.prototype.filterLayer = function (data) {
		let currentLayer = this.getCurrentLayer();
		if (currentLayer != null) {
			currentLayer.layer.setfiltro(data.query);
			currentLayer.data.records = data.records;
			this.updateCurrentLayer();
			this.fire(this.GEODIR.Event.FILTERLAYEREVENT, currentLayer);
		}
	};
	LayerAdmin.prototype.getMap = function () {
		return this.map;
	};
	LayerAdmin.prototype.initMapLayers = function (mapLayers) {
		this.maplayers = {
			columns: {},
			layers: {},
			widgets: {}
		};
		for (let cols in mapLayers.columns) {
			this.maplayers.columns[cols] = mapLayers.columns[cols];
		}
		for (let cols in mapLayers.widgets) {
			this.maplayers.widgets[cols] = mapLayers.widgets[cols];
		}
		for (let cols in mapLayers.layers) {
			this.maplayers.layers[cols] = mapLayers.layers[cols];
		}
		this.addLayers(mapLayers.layers);
	};
	LayerAdmin.prototype.getLayerColumnsCurrentlayer = function () {
		return this.maplayers.columns[this.currentLayerId];
	};
	LayerAdmin.prototype.getLayerColumns = function (layer) {
		return this.maplayers.columns[layer];
	};
	LayerAdmin.prototype.getWidgets = function () {
		return this.maplayers.widgets;
	};
	LayerAdmin.prototype.addColumn_Layer = function (layer, column) {
		let id = layer.data.id;
		let _column = {
			alias: column.label,
			aliasInfo: column.label,
			allowNull: true,
			foreingKey: false,
			name: column.model,
			pattern: null,
			size: 0,
			tableName: column.label.table,
			type: column.type
		};
		let col_name = column.model;
		this.maplayers.columns[id][col_name] = _column;
	};

	LayerAdmin.prototype.addLayers = function (layers) {

		for (let layer in layers) {
			let _zIndex = 15 + layers[layer].order;
			var _wmsLayer = null;

			var _layer = {
				data: layers[layer],
				layer: _wmsLayer
			}
			this.layers.overlays[layers[layer].id] = _layer;
		}
	};
	LayerAdmin.prototype.addOverlays = function (overlays) {
		this.layers.overlays = overlays;
	};
	LayerAdmin.prototype.getControlLayer = function () {
		return this.mapcontrols.controlLayer;
	};
	LayerAdmin.prototype.onbefore = function (type, fn, context) {
		var obj = this;
		var handler = function (e) {
			return fn.call(context || obj, e || window.event);
		};
		this._container.addEventListener(type, handler, false);
	};
	LayerAdmin.prototype.on = function (types, fn, context) {
		// types can be a map of types/handlers
		if (typeof types === 'object') {
			for (var type in types) {
				this._on(type, types[type], fn);
			}
		} else {
			types = L.Util.splitWords(types);
			for (var i = 0, len = types.length; i < len; i++) {
				this._on(types[i], fn, context);
			}
		}
		return this;
	};
	LayerAdmin.prototype._on = function (type, fn, context) {
		this._events = this._events || {};
		var typeListeners = this._events[type];
		if (!typeListeners) {
			typeListeners = [];
			this._events[type] = typeListeners;
		}
		if (context === this) {
			context = undefined;
		}
		var newListener = { fn: fn, ctx: context },
			listeners = typeListeners;
		for (var i = 0, len = listeners.length; i < len; i++) {
			if (listeners[i].fn === fn && listeners[i].ctx === context) {
				return;
			}
		}
		listeners.push(newListener);
	};
	LayerAdmin.prototype.fire = function (type, data, propagate) {
		//if (!this.listens(type, propagate)) { return this; }
		if (this._events) {
			var listeners = this._events[type];
			if (listeners) {
				this._firingCount = (this._firingCount + 1) || 1;
				for (var i = 0, len = listeners.length; i < len; i++) {
					var l = listeners[i];
					//l.fn.call(l.ctx || this, event);
					l.fn.call(data || this, window.event);
				}
				this._firingCount--;
			}
		}
		return this;
	};

	LayerAdmin.prototype.onAddLayer = function (fn, context) {
		var obj = this;
		var handler = function (e) {
			return fn.call(context || obj.layerAdded, e || window.event);
		};
		this._container.addEventListener('addLayer', handler, false);
	};

	LayerAdmin.prototype.addLayer = function (layer) {

		this.layers.overlays.push(layer);
	};
	LayerAdmin.prototype.initTemplate = function (serverContext) {
		//this.activeEvents();
	};

	LayerAdmin.prototype.setMap = function (map) {
		this.map = map;
	};

	LayerAdmin.prototype.changeVisible = function (id, visible) {
		if (!id) {
			return;
		}
		console.log(this.layers.overlays[id].layer);
		if (visible) {
			this.map.addLayer(this.layers.overlays[id].layer);
		} else {
			this.map.removeLayer(this.layers.overlays[id].layer);
		}
		var $token = $("meta[name='_csrf']");
		var $header = $("meta[name='_csrf_header']");
		var url = this.serverContext + 'geodir/ext/layer/changevisible/' + id
			+ "?visible=" + visible;
		$.ajax(
			{
				url: url,
				type: 'PUT',
				beforeSend: function (request) {
					if ($token != null && $token.length > 0
						&& $header != null && $header.length > 0) {
						request.setRequestHeader($header.attr("content"),
							$token.attr("content"));
					}
				}
			}).done(function (result) {
			}).fail(function (jqXHR, status) {
				console.log(jqXHR);
				console.log(status);
			});
	};





	LayerAdmin.prototype.getCurrentLayer = function () {
		return this.currentLayer;
	};
	LayerAdmin.prototype.updateCurrentLayer = function () {
		this.updateNumberOfFeatures(this.currentLayer); //actualiza la cantidad de registros segun el filtro
		this.currentLayer.layer.updateMapaStyle();

	};
	LayerAdmin.prototype.deleteGeodirlayer = function (id) {
		var $token = $("meta[name='_csrf']");
		var $header = $("meta[name='_csrf_header']");
		var url = this.serverContext + 'geodir/ext/layer/delete/' + id;
		var context = this;
		$.ajax(
			{
				url: url,
				type: 'DELETE',
				beforeSend: function (request) {
					if ($token != null && $token.length > 0
						&& $header != null && $header.length > 0) {
						request.setRequestHeader($header.attr("content"),
							$token.attr("content"));
					}
				}
			}).done(function (result) {
				console.log("Eliminado correctamente");
				context.map.removeLayer(context.layers.overlays[id].layer);
				delete context.layers.overlays[id];
				context.selectLayer(result);

				$("#geodir-layer-id-" + id).remove();
				return "OK";

			}).fail(function (jqXHR, status) {
				conso.log("Error en eliminar");
				console.log(jqXHR);
				console.log(status);
				return "FAILED";
			});
	};
	LayerAdmin.prototype.selectLayer = function (id) {
		var $token = $("meta[name='_csrf']");
		var $header = $("meta[name='_csrf_header']");

		var url = this.serverContext + 'geodir/ext/layer/select/' + id;
		var context = this;
		context.cancelControlActions(function () {
			$.ajax(
				{
					url: url,
					type: 'PUT',
					beforeSend: function (request) {
						if ($token != null && $token.length > 0
							&& $header != null && $header.length > 0) {
							request.setRequestHeader($header.attr("content"),
								$token.attr("content"));
						}
					}
				}).done(function (result) {
					if (result != 0) {
						context.currentLayer = context.layers.overlays[result];
						context.currentLayerId = result;
						console.log(context.currentLayer);
						//							if(context.currentLayer.data.editable){
						context.fire(context.GEODIR.Event.CHANGELAYEREVENT);
						//							}
						$('#geodir-layer-list').siblings().removeClass('active');
						if (!$('#geodir-layer-id-' + context.currentLayerId).hasClass("active")) {
							$('#geodir-layer-id-' + context.currentLayerId).addClass("active");
						}
					}

				}).fail(function (jqXHR, status) {
					console.log(jqXHR);
					console.log(status);
				})
		}
		);
	};
	LayerAdmin.prototype.reorderGeodirlayers = function (order) {
		var comp = this;
		var $token = $("meta[name='_csrf']");
		var $header = $("meta[name='_csrf_header']");
		let orderIds = order;
		var rowIds = order.join(",");
		var url = this.serverContext + 'geodir/ext/layer/reorder/' + rowIds;
		$.ajax(
			{
				url: url,
				type: 'PUT',
				beforeSend: function (request) {
					if ($token != null && $token.length > 0
						&& $header != null && $header.length > 0) {
						request.setRequestHeader($header.attr("content"),
							$token.attr("content"));
					}
				}
			}).done(function (result) {
				let maxIndex = orderIds.length;
				for (let i = 0; i < orderIds.length; i++) {
					for (let index in comp.layers.overlays) {
						if (comp.layers.overlays[index].data.id == orderIds[i]) {
							comp.layers.overlays[index].data.order = i;
							comp.layers.overlays[index].layer._setZIndex(15 + i);
						}
					}
				}
			}).fail(function (jqXHR, status) {
				console.log(jqXHR);
				console.log(status);
			});

	};

	function createInstance(GEODIR) {
		var object = new LayerAdmin(GEODIR);
		object.initTemplate(GEODIR.serverContext);
		return object;
	}
	return {
		getInstance: function (GEODIR) {
			console.log(GEODIR);
			if (!instance) {
				instance = createInstance(GEODIR);
				//GEODIR.fire('loaded',instance);
			}
			return instance;
		}
	};
})();

export default GeodirLayerAdmin;